import Fastify from "fastify";
import cors from "@fastify/cors";
import rateLimit from "@fastify/rate-limit";
import dbPlugin from "./plugins/db.js";
import jwtPlugin from "./plugins/jwt.js";
import redisPlugin from "./plugins/redis.js";
import bullmqPlugin from "./plugins/bullmq.js";
import errorHandlerPlugin from "./plugins/error-handler.js";
import authRoutes from "./modules/auth/auth.routes.js";
import { env } from "./config/env.js";
import {
  serializerCompiler,
  validatorCompiler,
  type ZodTypeProvider,
} from "fastify-type-provider-zod";
import whatsappRoutes from "./modules/whatsapp/whatsapp.routes.js";

export function buildApp() {
  const app = Fastify({
    logger: env.NODE_ENV === "production" ? false : true,
  }).withTypeProvider<ZodTypeProvider>();

  app.setValidatorCompiler(validatorCompiler);
  app.setSerializerCompiler(serializerCompiler);

  app.register(cors, {
    origin: "*",
    methods: ["GET", "POST", "PUT", "PATCH", "DELETE"],
  });

  app.register(dbPlugin);
  app.register(jwtPlugin);
  app.register(errorHandlerPlugin);
  app.register(redisPlugin);
  app.register(bullmqPlugin);

  app.get("/health", async () => {
    return {
      status: "ok",
      timestamp: new Date().toISOString(),
      uptime: process.uptime(),
    };
  });

  app.register(rateLimit, {
    max: 100,
    timeWindow: "1 minute",
  });

  app.register(authRoutes, { prefix: "/api/v1/auth" });
  app.register(whatsappRoutes, { prefix: "/api/v1/whatsapp" });

  return app;
}
